const ACADEMIC_YEAR_REGEX = /(\d{4})\s*-\s*(\d{2,4})/;

const CURRENT_ACADEMIC_YEAR_TOKEN = 'current academic year';
const UPCOMING_ACADEMIC_YEAR_TOKEN = 'upcoming academic year';
const PREVIOUS_ACADEMIC_YEARS_TOKEN = 'previous academic years';
const COMMUNITIES_AND_TRAINING_TOKEN = 'communities and training';

export const getAcademicYearStart = (label = '') => {
  const [, startYear] = label.match(ACADEMIC_YEAR_REGEX) || [];
  return startYear ? Number(startYear) : null;
};

export const getAccordionPriority = ({ categoryLabel = '', label = '' }) => {
  const lowerCategoryLabel = categoryLabel.toLowerCase();
  const lowerLabel = label.toLowerCase();
  const isCurrentYear = lowerLabel.includes(CURRENT_ACADEMIC_YEAR_TOKEN);
  const isUpcomingYear = lowerLabel.includes(UPCOMING_ACADEMIC_YEAR_TOKEN);
  const isStandaloneAcademicYear =
    lowerLabel.includes('academic year') && lowerCategoryLabel === lowerLabel;
  const isCommunityAndTraining =
    lowerCategoryLabel.includes(COMMUNITIES_AND_TRAINING_TOKEN) ||
    lowerLabel.includes(COMMUNITIES_AND_TRAINING_TOKEN);
  const isPreviousAcademicYear =
    lowerCategoryLabel.includes(PREVIOUS_ACADEMIC_YEARS_TOKEN) &&
    lowerLabel.includes('academic year');

  if (isCurrentYear) return 0;
  if (isStandaloneAcademicYear) return 0;
  if (isUpcomingYear) return 1;
  if (isCommunityAndTraining) return 2;
  if (isPreviousAcademicYear) return 3;
  return 4;
};

export const getDisplayAccordionLabel = (label = '') => {
  return label;
};
